/*
  <ws-accordion>: animates native <details> open and close, and with
  data-single-open closes the other answers when one opens.

  The details element still does the real work, so the questions open with
  no JavaScript and keep their built-in keyboard and screen reader support.
*/
if (!customElements.get('ws-accordion')) {
  customElements.define(
    'ws-accordion',
    class WsAccordion extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('details'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.items.forEach((item) => {
          const summary = item.querySelector('summary');
          if (!summary) return;
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            this.toggle(item, !item.open);
          });
        });

        if (window.Shopify && Shopify.designMode) {
          this.onBlockSelect = (event) => {
            const item = this.items.find((details) => details.contains(event.target));
            if (item) this.toggle(item, true);
          };
          this.addEventListener('shopify:block:select', this.onBlockSelect);
        }
      }

      toggle(item, open) {
        if (open && this.hasAttribute('data-single-open')) {
          this.items.forEach((other) => {
            if (other !== item && other.open) this.animate(other, false);
          });
        }
        this.animate(item, open);
      }

      animate(item, open) {
        const answer = item.querySelector('summary + *');
        if (item.wsAnimation) item.wsAnimation.cancel();

        if (!answer || this.reduceMotion.matches) {
          item.open = open;
          return;
        }

        if (open) item.open = true;
        const height = answer.scrollHeight;
        const frames = open
          ? [{ height: '0px', opacity: 0 }, { height: `${height}px`, opacity: 1 }]
          : [{ height: `${height}px`, opacity: 1 }, { height: '0px', opacity: 0 }];

        answer.style.overflow = 'hidden';
        item.wsAnimation = answer.animate(frames, { duration: 260, easing: 'ease' });
        item.wsAnimation.onfinish = () => {
          if (!open) item.open = false;
          answer.style.overflow = '';
          item.wsAnimation = null;
        };
        item.wsAnimation.oncancel = () => {
          answer.style.overflow = '';
        };
      }

      disconnectedCallback() {
        if (this.onBlockSelect) this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    }
  );
}
